import _ from 'lodash';

import { tags } from './tags';

function endpoints(builder) {
  return {
    getInformation: builder.query({
      query: () => 'actions/tefaf/exhibitorportal/gallery/get',
      providesTags: tags,
    }),
    updateInformation: builder.mutation({
      invalidatesTags: tags,
      query: (values) => {
        const body = new FormData();
        body.append(window.CRAFT_CSRF_PARAM, window.CRAFT_CSRF_TOKEN);
        if (!_.isNil(values.galleryName)) {
          body.append('fields[galleryName]', values.galleryName);
        }
        if (!_.isNil(values.gallerySpecialization)) {
          body.append('fields[gallerySpecialization]', values.gallerySpecialization);
        }
        if (!_.isNil(values.galleryTagline)) {
          body.append('fields[galleryTagline]', values.galleryTagline);
        }
        if (!_.isNil(values.contactPhone)) {
          body.append('fields[contactPhone]', values.contactPhone);
        }
        if (!_.isNil(values.contactEmail)) {
          body.append('fields[contactEmail]', values.contactEmail);
        }
        if (!_.isNil(values.website)) {
          body.append('fields[website]', values.website);
        }
        if (!_.isNil(values.galleryInquiryEmail)) {
          body.append('fields[galleryInquiryEmail]', values.galleryInquiryEmail);
        }
        if (!_.isNil(values.galleryDescription)) {
          body.append('fields[galleryDescription]', values.galleryDescription);
        }
        if (!_.isNil(values.galleryInsights)) {
          body.append('fields[galleryInsights]', values.galleryInsights);
        }
        if (!_.isNil(values.galleryArtistsRepresented)) {
          body.append('fields[galleryArtistsRepresented]', values.galleryArtistsRepresented);
        }
        if (!_.isNil(values.twitter)) {
          body.append('fields[twitter]', values.twitter);
        }
        if (!_.isNil(values.facebook)) {
          body.append('fields[facebook]', values.facebook);
        }
        if (!_.isNil(values.instagram)) {
          body.append('fields[instagram]', values.instagram);
        }
        if (!_.isNil(values.linkedin)) {
          body.append('fields[linkedin]', values.linkedin);
        }
        if (values.galleryPrimaryAddressSalesforceId) {
          body.append('fields[galleryPrimaryAddressSalesforceId]', values.galleryPrimaryAddressSalesforceId);
        }
        if (!_.isNil(values.galleryLocations)) {
          body.append('fields[galleryLocations]', '');
        }
        _.forEach(values.galleryLocations, ({
          id,
          locationName,
          email,
          addressLine1,
          addressLine2,
          city,
          stateProvince,
          postalCode,
          country,
          image,
        }) => {
          body.append('fields[galleryLocations][sortOrder][]', id);
          body.append(`fields[galleryLocations][entries][${id}][enabled]`, '1');
          body.append(`fields[galleryLocations][entries][${id}][type]`, 'location');
          body.append(`fields[galleryLocations][entries][${id}][fields][locationName]`, locationName || '');
          body.append(`fields[galleryLocations][entries][${id}][fields][email]`, email || '');
          body.append(`fields[galleryLocations][entries][${id}][fields][addressLine1]`, addressLine1 || '');
          body.append(`fields[galleryLocations][entries][${id}][fields][addressLine2]`, addressLine2 || '');
          body.append(`fields[galleryLocations][entries][${id}][fields][city]`, city || '');
          body.append(`fields[galleryLocations][entries][${id}][fields][stateProvince]`, stateProvince || '');
          body.append(`fields[galleryLocations][entries][${id}][fields][postalCode]`, postalCode || '');
          body.append(`fields[galleryLocations][entries][${id}][fields][country]`, country || '');
          _.forEach(image, (file) => {
            body.append(`fields[galleryLocations][entries][${id}][fields][image][]`, (_.isObject(file) && file.id ? file.id : file));
          });
        });
        if (!_.isNil(values.galleryExhibitions)) {
          body.append('fields[galleryExhibitions]', '');
        }
        _.forEach(values.galleryExhibitions, ({
          id,
          exhibitionTitle,
          subtitle,
          location,
          website,
          startDate,
          endDate,
          image,
        }) => {
          body.append('fields[galleryExhibitions][sortOrder][]', id);
          body.append(`fields[galleryExhibitions][entries][${id}][enabled]`, '1');
          body.append(`fields[galleryExhibitions][entries][${id}][type]`, 'exhibitions');
          body.append(`fields[galleryExhibitions][entries][${id}][fields][exhibitionTitle]`, exhibitionTitle || '');
          body.append(`fields[galleryExhibitions][entries][${id}][fields][subtitle]`, subtitle || '');
          body.append(`fields[galleryExhibitions][entries][${id}][fields][location]`, location || '');
          body.append(`fields[galleryExhibitions][entries][${id}][fields][website]`, website || '');
          body.append(`fields[galleryExhibitions][entries][${id}][fields][startDate]`, startDate || '');
          body.append(`fields[galleryExhibitions][entries][${id}][fields][endDate]`, endDate || '');
          _.forEach(image, (file) => {
            body.append(`fields[galleryExhibitions][entries][${id}][fields][image][]`, (_.isObject(file) && file.id ? file.id : file));
          });
        });
        if (!_.isNil(values.galleryContent)) {
          body.append('fields[galleryContent]', '');
        }
        _.forEach(values.galleryContent, ({
          id,
          type,
          text,
          images,
          video,
          poster,
        }) => {
          body.append('fields[galleryContent][sortOrder][]', id);
          body.append(`fields[galleryContent][entries][${id}][enabled]`, '1');
          body.append(`fields[galleryContent][entries][${id}][type]`, type);
          if (type === 'text') {
            body.append(`fields[galleryContent][entries][${id}][fields][text]`, text);
          }
          if (type === 'images') {
            _.forEach(images, (file) => {
              body.append(`fields[galleryContent][entries][${id}][fields][images][]`, (_.isObject(file) && file.id ? file.id : file));
            });
          }
          if (type === 'video') {
            body.append(`fields[galleryContent][entries][${id}][fields][video]`, video);
            _.forEach(poster, (file) => {
              body.append(`fields[galleryContent][entries][${id}][fields][poster][]`, (_.isObject(file) && file.id ? file.id : file));
            });
          }
        });

        return {
          url: 'actions/tefaf/exhibitorportal/gallery/save',
          method: 'POST',
          body,
        };
      },
    }),
    createAddress: builder.mutation({
      invalidatesTags: tags,
      query: (values) => {
        const body = new FormData();
        body.append(window.CRAFT_CSRF_PARAM, window.CRAFT_CSRF_TOKEN);
        body.append('action', values.action);
        if (values.addressId) {
          body.append('id', values.addressId);
        }
        body.append('fields[address1]', values.address1);
        body.append('fields[address2]', values.address2);
        body.append('fields[city]', values.city);
        body.append('fields[state]', values.state);
        body.append('fields[postalCode]', values.postalCode);
        body.append('fields[country]', values.country);

        return {
          url: '/',
          method: 'POST',
          body,
        };
      },
    }),
    removeAddress: builder.mutation({
      invalidatesTags: tags,
      query: (values) => {
        const body = new FormData();
        body.append(window.CRAFT_CSRF_PARAM, window.CRAFT_CSRF_TOKEN);
        body.append('action', 'tefaf/exhibitorportal/address/remove');
        body.append('id', values.addressId);

        return {
          url: '/',
          method: 'POST',
          body,
        };
      },
    }),
    createContact: builder.mutation({
      invalidatesTags: tags,
      query: (values) => {
        const body = new FormData();
        body.append(window.CRAFT_CSRF_PARAM, window.CRAFT_CSRF_TOKEN);
        body.append('action', values.action);
        if (values.contactId) {
          body.append('id', values.contactId);
        }
        body.append('fields[salutation]', values.salutation);
        body.append('fields[firstName]', values.firstName);
        body.append('fields[lastName]', values.lastName);
        body.append('fields[title]', values.title);
        body.append('fields[phone]', values.phone);
        body.append('fields[email]', values.email);

        return {
          url: '/',
          method: 'POST',
          body,
        };
      },
    }),
    removeContact: builder.mutation({
      invalidatesTags: tags,
      query: (values) => {
        const body = new FormData();
        body.append(window.CRAFT_CSRF_PARAM, window.CRAFT_CSRF_TOKEN);
        body.append('action', 'tefaf/exhibitorportal/contact/remove');
        body.append('id', values.contactId);

        return {
          url: '/',
          method: 'POST',
          body,
        };
      },
    }),
    saveUser: builder.mutation({
      invalidatesTags: tags,
      query: (values) => {
        const body = new FormData();
        body.append(window.CRAFT_CSRF_PARAM, window.CRAFT_CSRF_TOKEN);
        body.append('action', 'tefaf/exhibitorportal/staff-member/save');
        if (values.userId) {
          body.append('id', values.userId);
        }
        body.append('firstName', values.firstName);
        body.append('lastName', values.lastName);
        body.append('email', values.email);
        body.append('fields[salutation]', values.salutation);
        body.append('fields[jobTitle]', values.jobTitle);
        body.append('fields[mobilePhone]', values.mobilePhone);
        body.append('fields[businessPhone]', values.businessPhone);
        body.append('fields[profilePicture][]', '');
        _.forEach(values.profilePicture, (file) => {
          body.append('fields[profilePicture][]', (_.isObject(file) && file.id ? file.id : file));
        });
        body.append('fields[onlineRepresentative]', values.onlineRepresentative);

        return {
          url: '/',
          method: 'POST',
          body,
        };
      },
    }),
    removeUser: builder.mutation({
      invalidatesTags: tags,
      query: (values) => {
        const body = new FormData();
        body.append(window.CRAFT_CSRF_PARAM, window.CRAFT_CSRF_TOKEN);
        body.append('action', 'tefaf/exhibitorportal/staff-member/remove');
        body.append('id', values.userId);

        return {
          url: '/',
          method: 'POST',
          body,
        };
      },
    }),
  };
}

export { endpoints };
